import { createContext } from 'react';

const AuthenticatedContext = createContext<any[]>([]);

export default AuthenticatedContext;
